import React from 'react';
import Landmark from '@core/scripts/components/landmark-adapter';
import {Constants} from '../view-constants';

function Ipic({color, index, activeIndex, shopId, channelId, onChangeItem, inView}) {
    const previewImage = color?.previewImage?.image?.src && inView ? color.previewImage : false;
    const colorHex = color?.colorHex ? color.colorHex : false;
    const isSelected = index === activeIndex;
    const imageStyles = {
        width: `${previewImage.widthPercent}%`,
        backgroundPositionX: `${previewImage.offsetPercent}%`,
    }
    const imagesStylesDefault = previewImage ?
        {
            ...imageStyles,
            backgroundImage: `url(${previewImage.image.src})`,

        }
        : {};
    const imagesStyles2x = previewImage ?
        {
            ...imageStyles,
            backgroundImage: `url(${previewImage.image.src2x})`,
        }
        : {};
    const colorBubbleBackgroundHex = {backgroundColor: `${colorHex}`};
    const colorBubbleBackgroundBlack = {backgroundColor: '#000000'};

    return (
        <>
            <div className="alpi__color-slide" onClick={handleIpicClick} onMouseOver={() => onChangeItem(color)}>
                {previewImage ? (
                    <span className="alpi__color">
                        <span
                            className="alpi__picture-wrapper alpi__picture-wrapper-retina"
                            style={imagesStyles2x}
                        ></span>
                        <span
                            className="alpi__picture-wrapper alpi__picture-wrapper-non-retina"
                            style={imagesStylesDefault}
                        ></span>
                    </span>
                ) : (
                    <span className="alpi__color">
                        {colorHex ? (
                            <div className="alpi__color-bubble" style={colorBubbleBackgroundHex}></div>
                        ) : (
                            <div className="alpi__color-bubble" style={colorBubbleBackgroundBlack}></div>
                        )}
                    </span>
                )}
            </div>
            {isSelected ? <div className="alpi__selected-line"></div> : <></>}
        </>
    );

    function handleIpicClick() {
        setTimeout(() => {
            const pageType = shopId === 0 ? Constants.LANDMARK_PAGETYPE_SRP : Constants.LANDMARK_PAGETYPE_AOP;
            const lmValue = `${pageType}\\color\\\\${color.itemNumber}\\${channelId}\\${shopId}\\${color.id}`;
            Landmark.sendClickLandmark(lmValue);
            onChangeItem(color);
        }, 0)
    }
}

export default Ipic